import React from "react";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import plusicon from "../../assets/images/plusicon.svg";
import { useGetUserInformation } from "../../features/users";
import { useGetSidebarBusinessList } from "../../lib/queries/queriesAndMutations";
import { getImage } from "../../utils/utils";
import PosIcon from "../shared/PosIcon";

// Button to add a new business, disabled if user isn't verified
const AddBusinessButton = ({ disabled }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (disabled) {
      toast.error("ایجاد کسب وکار جدید برای شما امکان پذیر نیست");
    } else {
      navigate("/business/new");
    }
  };

  return (
    <button title="افزودن کسب و کار" onClick={handleClick} tabIndex={-1} className=" min-w-16 min-h-16 p-2 ">
      <img
        src={plusicon}
        alt="addIcon"
        className="bg-primary-50  p-2 rounded-xl hover:bg-primary-30 border border-white w-full "
      />
    </button>
  );
};

// Individual business item
const BusinessItem = ({ item }) => {
  const navigate = useNavigate();
  const handleClick = () => navigate(`/business/${item.business_type}/${item.id}`);

  return (
    <div
      className="flex flex-col gap-1 items-center hover:bg-primary-90 p-1 rounded-xl cursor-pointer"
      title={item.fa_name}
      onClick={handleClick}
    >
      <div className="relative">
        {item.pose_specific ? (
          <PosIcon src={getImage(item.logo_preview)} />
        ) : (
          <img
            src={getImage(item.logo_preview) || "/images/briefcase.svg"}
            alt={item.fa_name}
            className="w-12 h-12 rounded-xl"
          />
        )}
      </div>
      <p className="truncate w-16 text-center text-sm">{item.fa_name}</p>
    </div>
  );
};

// List of businesses or a loader
const BusinessList = ({ businesses, isLoading, userIsValid }) => {
  // if (!userIsValid) return null;
  if (!businesses?.count) return null;
  if (isLoading) return <SideBarBusinessLoader />;
  return (
    <div className="flex flex-col gap-2 overflow-y-auto py-4 px-2 items-center max-h-96 w-fit rounded-lg no-scrollbar">
      {businesses.items.map((item) => (
        <BusinessItem key={item.id} item={item} />
      ))}
    </div>
  );
};

// Main Sidebar component
const Sidebar = () => {
  const { data: user } = useGetUserInformation();
  const userIsValid = user?.verified;
  const { data: businessList, isPending } = useGetSidebarBusinessList({
    currentPage: 1,
    pageSize: 100,
    userIsValid,
  });

  console.log(businessList, "businessList");
  const profileAvatar = user?.profile_picture_preview;

  const avatarSrc = profileAvatar
    ? profileAvatar.startsWith("https")
      ? profileAvatar
      : import.meta.env.VITE_STORAGE_ENDPOINT + profileAvatar
    : "/images/avatar.png";

  // Avatar with conditional navigation or error
  const ProfileAvatar = () => {
    const navigate = useNavigate();
    const handleClick = () => navigate("/profile");

    return (
      <img
        src={avatarSrc}
        alt="a"
        width={68}
        height={68}
        className="rounded-xl cursor-pointer hover:shadow-sm"
        onClick={handleClick}
      />
    );
  };

  return (
    <div className="flex gap-2 p-1 bg-primary-20 h-full rounded-xl">
      <div className="flex flex-col items-center gap-2 ">
        <ProfileAvatar />
        <div className="flex flex-col items-center w-full bg-primary-20 rounded-xl">
          <BusinessList businesses={businessList} isLoading={isPending} userIsValid={userIsValid} />
          <AddBusinessButton disabled={!userIsValid} />
        </div>
      </div>
    </div>
  );
};

export default Sidebar;

const SideBarBusinessLoader = () => {
  const array = new Array(4).fill(null).map((u, i) => i);

  return (
    <div className="bg-slate-300 px-2 pt-3 pb-8  space-y-2">
      {array.map((_, i) => {
        return (
          <div key={i} className="w-10 h-10 ">
            <Skeleton className="h-full" />
          </div>
        );
      })}
    </div>
  );
};
